'use strict';

class PageUtils {

  static getReadablePublishDate(page) {

    var publishDate = (page.publishDate ? page.publishDate : page.created);

    var months = ['January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'];

    var day = new Date(publishDate).getDate();
    var monthIndex = new Date(publishDate).getMonth();
    var month = months[monthIndex];
    var year = new Date(publishDate).getFullYear();

    return day + " " + month + " " + year;

  }

  static getUrlWithProtocol(imageUrl) {
    return (!!imageUrl && imageUrl.indexOf('http') == -1) ? ('https:' + imageUrl) : imageUrl;
  }

  static getAllImagesOnContent(content) {

    var srcRegexp = /\<img.*share-image="(.*?)"/g

    var matches = [];
    var match;
    while (match = srcRegexp.exec(content)) {
      matches.push(PageUtils.getUrlWithProtocol(match[1]));
    }

    return matches;
  }

  static formatMoney(n, c, d = '.', t = ','){

    c = isNaN(c = Math.abs(c)) ? 2 : c;
    let s = n < 0 ? "-" : "";
    let i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "";
    let j = (i.length) > 3 ? i.length % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");

  }

}

module.exports = PageUtils;



// WEBPACK FOOTER //
// ./common/utils/pageutils.js